import { useMemo } from "react";

import { typedQueryClient } from "hooks/useTypedQuery";
import { MANUFACTURER_REQUEST_STATUSES } from "models";
import { ManufacturerQueryKeys } from "modules/ManufacturerDashboard/queryKeys";

import type { WebSocketMessageListener } from "components";
import type { ManufacturerRequest } from "models";

export const useManufacturerDashboardListeners = () => {
  const listeners = useMemo(() => {
    const manufacturerRequestListeners: WebSocketMessageListener<ManufacturerRequest>[] = [
      {
        model: "ManufacturerRequest",
        action: "upsert",
        callback: message => {
          const currentManufacturerCount = typedQueryClient.getQueryData(ManufacturerQueryKeys.manufacturerRequestCount);
          if (!currentManufacturerCount) return;

          const result = message.data;

          typedQueryClient.setQueryData(
            ManufacturerQueryKeys.manufacturerRequestCount,
            currentManufacturerCount + (result.status === MANUFACTURER_REQUEST_STATUSES.Pending ? 1 : -1)
          );
        }
      }
    ];

    return [...manufacturerRequestListeners];
  }, []);

  return listeners;
};
